// src/pages/driverReports/statementComponents/CarPLSheet.js
import React, { useState } from "react";
import ExpensesTable from "./ExpensesTable";
import WeeklyTable from "./WeeklyTable";
import CashTable from "./CashTable";
import { exportSheetToPDF, exportSheetToExcel } from "../carSheets/exportUtils";

export default function CarPLSheet({ sheet, month, asOfDatePreview = "", onForceRebuild }) {
  const [exporting, setExporting] = useState(false);
console.log("📋 CarPLSheet Data:", {
  sheetId: sheet.id,
  carNumber: sheet.carNumber,
  sheetDrivers: sheet.drivers,
  driverPeriods: sheet.driverPeriods,
  incomeDrivers: sheet.incomeRows?.map(r => r.driver).filter(Boolean),
  cashDrivers: sheet.cashRows?.map(r => r.driver).filter(Boolean)
});
  const handleExport = async (format) => {
    try {
      setExporting(true);
      if (format === "pdf") {
        await exportSheetToPDF(sheet, month);
      } else if (format === "excel") {
        await exportSheetToExcel(sheet, month);
      }
    } catch (error) {
      console.error("Export error:", error);
      alert(`Export failed: ${error.message}`);
    } finally {
      setExporting(false);
    }
  };

  // Collect fines
  const getFineData = () => {
    const fines = [];
    for (let i = 1; i <= 12; i++) {
      const fine = sheet[`fine${i}`];
      const fineDate = sheet[`fineDate${i}`];
      if (fine || fineDate) {
        fines.push({
          number: i,
          fine: fine || "-",
          date: fineDate || "-",
        });
      }
    }
    return fines;
  };

  const fineData = getFineData();

    /* ----------------------------------------------------------------------
     ⭐ TEMPORARY FIX: Show drivers from ANY source when driverPeriods is empty
  ---------------------------------------------------------------------- */
  
  // Check if driverPeriods is empty
  const hasDriverPeriods = sheet.driverPeriods && Object.keys(sheet.driverPeriods).length > 0;
  
  let allDrivers = [];
  
  if (hasDriverPeriods) {
  // ⭐⭐ TEMPORARY: Show ALL drivers from driverPeriods without cleaning
  const rawDrivers = Object.values(sheet.driverPeriods || {})
  .map(periods => (Array.isArray(periods) ? periods[0] : periods))
  .map(p => p?.driverName)
  .filter(name => name && name.trim() !== "");

    
  console.log("🔍 RAW DRIVERS FROM PERIODS:", rawDrivers);
  
  // Clean function to remove POS devices
  const cleanDriverList = (drivers) => {
    return drivers.filter(driver => {
      const upper = String(driver).toUpperCase();
      return !upper.includes("POS DEVICE") && 
             !upper.includes("POS_DEVICE") && 
             !upper.includes("(POS)");
    });
  };

  allDrivers = cleanDriverList(rawDrivers);
  
  console.log("🔍 CLEANED DRIVERS:", {
    rawCount: rawDrivers.length,
    cleanedCount: allDrivers.length,
    rawNames: rawDrivers,
    cleanedNames: allDrivers
  });
  
} else {
    // ⭐⭐ TEMPORARY FALLBACK: Get drivers from ALL sources
    const driverSet = new Set();

    // 1) From sheet.drivers array
    (sheet.drivers || []).forEach((d) => {
      if (d && !String(d).toUpperCase().includes("POS")) driverSet.add(d);
    });

    // 2) From income rows (when no assignments)
    (sheet.incomeRows || []).forEach((r) => {
      if (r.driver && !String(r.driver).toUpperCase().includes("POS"))
        driverSet.add(r.driver);
    });

    // 3) From cash rows (when no assignments)
    (sheet.cashRows || []).forEach((r) => {
      if (r.driver && !String(r.driver).toUpperCase().includes("POS"))
        driverSet.add(r.driver);
    });

    allDrivers = Array.from(driverSet);
    
    console.warn("⚠️ NO driverPeriods found! Using income/cash rows as fallback for:", sheet.carNumber);
  }

  console.log("🔍 FINAL DRIVERS:", {
    carNumber: sheet.carNumber,
    hasDriverPeriods,
    allDrivers,
    source: hasDriverPeriods ? "driverPeriods" : "income/cash fallback"
  });

  // Format dates nicely
  const formatDate = (d) => {
    if (!d) return "-";
    const dateObj = d.seconds ? new Date(d.seconds * 1000) : new Date(d);
    return dateObj.toLocaleDateString("en-GB");
  };

  return (
    <div style={{ paddingBottom: 40, paddingRight: 8 }}>
      {asOfDatePreview && (
        <div
          style={{
            padding: 10,
            marginBottom: 12,
            background: "#e0f2fe",
            border: "1px solid #38bdf8",
            borderRadius: 6,
            color: "#075985",
            fontSize: 13,
            fontWeight: 600,
          }}
        >
          Installment preview as of {asOfDatePreview}. This is only for viewing MD position; saved car sheet data is unchanged.
        </div>
      )}

      {/* HEADER */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 12,
        }}
      >
        <div style={{ textAlign: "center", flex: 1 }}>
          <div style={{ fontWeight: "bold", textTransform: "uppercase" }}>
            {sheet.monthLabel}
          </div>
          <div style={{ fontWeight: "bold", marginTop: 4 }}>
  PROFIT &amp; LOSS CAR NO. {sheet.carNumber} {sheet.carModel}
</div>

{sheet.periodLabel && (
  <div style={{ fontSize: 12, color: "#555", marginTop: 4 }}>
    Period: {sheet.periodLabel}
  </div>
)}
        </div>

        <div style={{ display: "flex", gap: "8px" }}>
          <button
            onClick={() => handleExport("pdf")}
            disabled={exporting}
            style={{
              padding: "6px 12px",
              background: "#d32f2f",
              color: "white",
              border: "none",
              borderRadius: "4px",
              cursor: exporting ? "not-allowed" : "pointer",
              fontSize: "13px",
            }}
          >
            {exporting ? "Exporting..." : "Export PDF"}
          </button>

          <button
            onClick={() => handleExport("excel")}
            disabled={exporting}
            style={{
              padding: "6px 12px",
              background: "#2e7d32",
              color: "white",
              border: "none",
              borderRadius: "4px",
              cursor: exporting ? "not-allowed" : "pointer",
              fontSize: "13px",
            }}
          >
            {exporting ? "Exporting..." : "Export Excel"}
          </button>
        </div>
      </div>

            {/* DRIVER HEADER - WITH FALLBACK SUPPORT */}
      <div style={{ marginTop: 16, fontSize: 14 }}>
        {allDrivers.length === 0 ? (
          <div style={{ color: '#ff9800', fontStyle: 'italic', padding: '8px', background: '#fff3e0', borderRadius: '4px' }}>
            ⚠️ No driver assignment data available
          </div>
        ) : (
          allDrivers.map((name, index) => {
            // Try to find this driver in driverPeriods
            let entry = null;

if (sheet.driverPeriods) {
  for (const driverId in sheet.driverPeriods) {
    const periods = sheet.driverPeriods[driverId];
    const list = Array.isArray(periods) ? periods : [periods];

    if (list.some(p => p?.driverName === name)) {
      const first = list[0] || {};
      const last = list[list.length - 1] || {};
      entry = { first, last };
      break;
    }
  }
}

const startVal = entry?.first?.startDate || entry?.first?.start;
const endVal = entry?.last?.endDate || entry?.last?.end;

const start = startVal ? formatDate(startVal) : "N/A";
const end = endVal ? formatDate(endVal) : "N/A";


            return (
              <div
                key={index}
                style={{
                  marginBottom: 6,
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                }}
              >
                <strong style={{ minWidth: 70 }}>Driver {index + 1}:</strong>

                <span style={{ fontWeight: 600 }}>{name}</span>

                {(start !== "N/A" || end !== "N/A") ? (
                  <span
                    style={{
                      background: "#f1f1f1",
                      padding: "3px 10px",
                      borderRadius: 12,
                      fontSize: 12,
                      color: "#555",
                      border: "1px solid #ddd",
                    }}
                  >
                    {start} → {end}
                  </span>
                ) : (
                  <span
                    style={{
                      background: "#ffebee",
                      padding: "3px 10px",
                      borderRadius: 12,
                      fontSize: 12,
                      color: "#c62828",
                      border: "1px solid #ffcdd2",
                      fontStyle: 'italic'
                    }}
                  >
                    No assignment dates
                  </span>
                )}
              </div>
            );
          })
        )}
      </div>

      {/* FINES */}
      {fineData.length > 0 && (
        <>
          <h3 style={{ marginTop: 24, marginBottom: 8 }}>FINES</h3>
          <div
            style={{
              overflowX: "auto",
              border: "1px solid #ccc",
              borderRadius: "4px",
              marginBottom: 20,
            }}
          >
            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                fontSize: 13,
                minWidth: "600px",
              }}
            >
              <thead>
                <tr style={{ backgroundColor: "#f3f4f6" }}>
                  <th style={thStyle}>Fine #</th>
                  <th style={thStyle}>Fine Amount</th>
                  <th style={thStyle}>Fine Date</th>
                </tr>
              </thead>
              <tbody>
                {fineData.map((item, index) => (
                  <tr
                    key={index}
                    style={{
                      backgroundColor: index % 2 === 0 ? "white" : "#f8f9fa",
                      borderTop: "1px solid #e5e7eb",
                    }}
                  >
                    <td style={{ ...tdStyle, borderLeft: "1px solid #e5e7eb" }}>
                      Fine {item.number}
                    </td>
                    <td style={tdStyle}>{item.fine}</td>
                    <td
                      style={{ ...tdStyle, borderRight: "1px solid #e5e7eb" }}
                    >
                      {item.date}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}

      {/* EXPENSES */}
      <h3 style={{ marginTop: fineData.length > 0 ? 0 : 24, marginBottom: 8 }}>
        EXPENSES
      </h3>
      <ExpensesTable rows={sheet.expensesRows} readOnly />

      {/* INCOME */}
      <h3 style={{ marginTop: 24, marginBottom: 8 }}>INCOME</h3>
      <WeeklyTable
        title="Company / Driver Income (Week-wise)"
        rows={sheet.incomeRows}
        readOnly
      />

      {/* CASH */}
      <h3 style={{ marginTop: 24, marginBottom: 8 }}>CASH TRIPS</h3>
      <CashTable rows={sheet.cashRows} readOnly />
    </div>
  );
}

const thStyle = {
  border: "1px solid #ccc",
  padding: 8,
  textAlign: "left",
  background: "#f3f4f6",
  fontWeight: "bold",
};

const tdStyle = {
  border: "1px solid #e5e7eb",
  padding: 8,
  verticalAlign: "middle",
};
